import { EndpointBuilder } from "@reduxjs/toolkit/dist/query/endpointDefinitions";
import {
  ChangelogItem,
  ResourcePlanOverviewTableRowData,
} from "@src/types/resource_plan_types";
import { message } from "antd";

import { baseApiSlice } from "./baseApiSlice";

export const resourcePlanApi = baseApiSlice.injectEndpoints({
  endpoints: (builder: EndpointBuilder<any, any, any>) => ({
    /* GET endpoints */
    ...getEndpoints(builder),
  }),
});

function getEndpoints(builder: EndpointBuilder<any, any, any>) {
  return {
    /**
     * Get all resource plans.
     */
    getResourcePlans: builder.query<ResourcePlanOverviewTableRowData[], void>({
      query: () => "/resource-plans",
      transformErrorResponse: async () => {
        message.error("Failed to get resource plans", 5);
      },
      providesTags: ["ResourcePlan"],
    }),
    /**
     * Get changelog history
     */
    getResourcePlanChangelog: builder.query<ChangelogItem[], string>({
      query: (resourcePlanId) =>
        `/v2/resource-plans/${resourcePlanId}/changelog`,
      transformErrorResponse: async () => {
        message.error("Failed to get changelog", 5);
      },
      providesTags: ["ResourcePlan", "RoleRequests"],
    }),
  };
}

export const {
  // GET
  useGetResourcePlansQuery,
  useGetResourcePlanChangelogQuery,
} = resourcePlanApi;
